export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";